import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { DimentionTypes } from "@/components/dimention-field/DimentionField";
import { DimentionProps } from "./types";

const PROPS: (keyof DimentionProps)[] = ["width", "maxWidth", "height", "maxHeight"];

const useNormalizeDimentions = (props: DimentionProps) => {
  const responsive = useResponsiveValues();

  const draft = useMemo(() => {
    const draft: DimentionProps = {};

    PROPS.forEach((prop) => {
      if (props[prop]) {
        const value = responsive.getValue(props[prop]);
        const unit = responsive.getValue(props?.[prop + "Type"]) ?? DimentionTypes.PIXELS;

        draft[prop] = value ? `${value}${unit}` : undefined;
      }
    });

    return draft;
  }, [props, responsive]);
  return draft;
};

export default useNormalizeDimentions;
